var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"text--small grey--text"},[_vm._v("v"+_vm._s(_vm.version))])
}
var staticRenderFns = []

export { render, staticRenderFns }